module.exports = __webpack_public_path__ + "img/cloudscale-black.05c818ff.svg";